import { Select, MenuItem, InputLabel, FormControl, TextField, IconButton, Grid, FormHelperText } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useFormikContext, Field } from "formik";
import { logicalOperatorRules } from "../../../../../constants";

const Validation = ({ index, validationIndex, deleteValidation }) => {
  const { values, errors, setFieldValue } = useFormikContext();
  const path = `conditionalFields.${index}.validations.${validationIndex}`;
  const validationErrors = errors?.conditionalFields?.[index]?.validations?.[validationIndex];
  const { rule, aggregation } = values.conditionalFields[index].validations[validationIndex];
  const isAccumulated = aggregation === "sum";
  const isRuleValueRequired = rule !== "is_empty" && rule !== "is_not_empty";

  return (
    <Grid container spacing={2} alignItems="flex-start">
      <Grid item xs={5}>
        <Field
          name={`${path}.rule`}
          validate={(rule) =>
            isAccumulated && !logicalOperatorRules.includes(rule) ? "Select a rule for the total." : undefined
          }
        >
          {({ field }) => (
            <FormControl fullWidth error={!!validationErrors?.rule}>
              <InputLabel id={`${path}.rule-label`} size="small">
                Rule
              </InputLabel>
              <Select
                {...field}
                id={`${path}.rule`}
                labelId={`${path}.rule-label`}
                label="Rule"
                size="small"
                value={field.value ?? ""}
                onChange={(event) => {
                  field.onChange(event);
                  setFieldValue(
                    `${path}.ruleValue`,
                    ["is_empty", "is_not_empty"].includes(event.target.value) ? undefined : "",
                  );
                }}
              >
                {logicalOperatorRules.map((rule) => (
                  <MenuItem key={rule} value={rule}>
                    {rule.replace(/_/g, " ")}
                  </MenuItem>
                ))}
              </Select>
              {!!validationErrors?.rule && <FormHelperText>{validationErrors.rule}</FormHelperText>}
            </FormControl>
          )}
        </Field>
      </Grid>
      {isRuleValueRequired && (
        <Grid item xs={5}>
          <Field
            name={`${path}.ruleValue`}
            validate={(value) =>
              isAccumulated && (value == null || String(value).trim() === "" || !Number.isFinite(Number(value)))
                ? "Enter a numeric total."
                : undefined
            }
          >
            {({ field }) => (
              <TextField
                {...field}
                fullWidth
                id={`${path}.ruleValue`}
                label="Value"
                size="small"
                type={isAccumulated ? "number" : "text"}
                inputProps={isAccumulated ? { step: "any" } : undefined}
                value={field.value ?? ""}
                error={!!validationErrors?.ruleValue}
                helperText={validationErrors?.ruleValue}
              />
            )}
          </Field>
        </Grid>
      )}
      <Grid item xs={2}>
        <IconButton color="primary" onClick={deleteValidation} size="small" aria-label="Delete validation">
          <ClearIcon fontSize="small" />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export { Validation };
